import React from 'react';
import { Field } from 'redux-form';

import styles from './SearchForm.css';

class Search extends React.Component {
  render() {
    return (
      <div className={`row ${styles.wrapper}`}>
        <div className="col-md-12">
          <div className="right-inner-addon">
            <i className="fa fa-search" />
            <Field
              component="input"
              name="keyword"
              className="form-control"
              placeholder="search"
              onChange={this.onChange}
            />
          </div>
        </div>
      </div>
    );
  }

  onChange = (event, value) => {
    const { applySetItemItemsRequest } = this.props;
    applySetItemItemsRequest({ page: 0, keyword: value }, []);
  };
}

export default Search;
